import React, { useState, useEffect } from "react";
import { Row, Col, Form, Dropdown } from "react-bootstrap";
import { FaChartLine } from "react-icons/fa";
import { HiMiniUserGroup } from "react-icons/hi2";
import { FaPencilAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import axios from '../../Authservices/axiosInstance';
import "bootstrap/dist/css/bootstrap.min.css";
import "./roles.css";

export default function Salary() {
  const rowsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState(""); // State for search input

  // Fetch data with search query
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `https://backend.ems.uk.hiradentallab.com/api/user/user-roles?search=${search}` // Pass search query
        );
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [search]); // Refetch when search query changes

  const handleSearchChange = (e) => {
    setSearch(e.target.value); // Update search state dynamically
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(data.length / rowsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };

  const pageRange = () => {
    const pages = [];
    const totalPages = Math.ceil(data.length / rowsPerPage);
    let startPage = Math.max(currentPage - 1, 1);
    let endPage = Math.min(startPage + 2, totalPages);

    if (endPage - startPage < 2) {
      startPage = Math.max(endPage - 2, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  const totalEntries = data.length; // Ensure totalEntries is defined

  return (
    <div className="container-fluid">
      <div>
        <h1 className="roles-title">
          <FaChartLine className="salary-icon" /> Employee Role Information
        </h1>
        <hr />
        <h2 className="roles-subtitle">
          <HiMiniUserGroup className="salary-icon" /> Employee's Role
        </h2>
        <hr />
        <div className="table-container">
          <div className="filter-container">
            <Col xs={12} md={6} className="filter-left">
              <Dropdown className="d-inline mx-2" autoClose="inside">
                <Dropdown.Toggle id="dropdown-autoclose-inside">
                  Show Entries
                </Dropdown.Toggle>
                <Dropdown.Menu className="custom-dropdown-menu">
                  <Dropdown.Item href="#">15</Dropdown.Item>
                  <Dropdown.Item href="#">25</Dropdown.Item>
                  <Dropdown.Item href="#">50</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col xs={12} md={6} className="filter-right">
              <Form className="d-flex" onSubmit={(e) => e.preventDefault()}>
                <Form.Control
                  type="search"
                  placeholder="Search"
                  aria-label="Search"
                  className="search-bar"
                  value={search}
                  onChange={handleSearchChange} // Handle input changes dynamically
                />
              </Form>
            </Col>
          </div>
          <div className="table-responsive">
            {loading ? (
              <p>Loading...</p>
            ) : data.length > 0 ? (
              <table className="table table-striped table-style">
                <thead className="tablehead">
                  <tr className="table-header-footer">
                    <th>SR</th>
                    <th>UserID</th>
                    <th>Employee Name</th>
                    <th>Department</th>
                    <th>Department Role</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {data
                    .slice(
                      (currentPage - 1) * rowsPerPage,
                      currentPage * rowsPerPage
                    )
                    .map((employee, index) => (
                      <tr key={employee.userId}>
                        <td>
                          {(currentPage - 1) * rowsPerPage + index + 1}
                        </td>
                        <td>{employee.userId}</td>
                        <td>{employee.name}</td>
                        <td>
                          {employee.department
                            ? employee.department.name
                            : "N/A"}
                        </td>
                        <td>
                          {employee.departmentRole
                            ? employee.departmentRole.name
                            : "N/A"}
                        </td>
                        <td>
                          <Link
                            to={`/edit-user-role/${employee.userId}`}
                            title="Edit"
                            className="icon-link"
                          >
                            <FaPencilAlt />
                          </Link>
                        </td>
                      </tr>
                    ))}
                </tbody>
                <tfoot className="table-footer">
                  <tr className="departments-table-footer">
                    <td>Total</td>
                    <td>-</td>
                    <td>{data.length}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            ) : (
              <p>No data available or an error occurred while fetching data.</p>
            )}

            <Row className="mt-2">
              <Col xs={12} md={6} className="d-flex align-items-center">
                <p className="showing-entries">
                  Showing {(currentPage - 1) * rowsPerPage + 1} to{" "}
                  {Math.min(currentPage * rowsPerPage, totalEntries)} of{" "}
                  {totalEntries} entries
                </p>
              </Col>
              <Col xs={12} md={6} className="d-flex justify-content-end">
                <nav>
                  <ul className="pagination">
                    <li
                      className={`page-item ${
                        currentPage === 1 ? "disabled" : ""
                      }`}
                    >
                      <a
                        href="/#"
                        className="page-link"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageChange(currentPage - 1);
                        }}
                      >
                        Previous
                      </a>
                    </li>
                    {pageRange().map((page) => (
                      <li
                        key={page}
                        className={`page-item ${
                          currentPage === page ? "active" : ""
                        }`}
                      >
                        <a
                          href="/#"
                          className="page-link"
                          onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(page);
                          }}
                        >
                          {page}
                        </a>
                      </li>
                    ))}
                    <li
                      className={`page-item ${
                        currentPage === Math.ceil(totalEntries / rowsPerPage)
                          ? "disabled"
                          : ""
                      }`}
                    >
                      <a
                        href="/#"
                        className="page-link"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageChange(currentPage + 1);
                        }}
                      >
                        Next
                      </a>
                    </li>
                  </ul>
                </nav>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
}
